import React, { useState, useEffect } from 'react';

//local import
import MasonaryLayout from './MasonaryLayout';
import { client } from '../client';
import { searchQuery, feedQuery } from '../utlis/data';
import Spinner from './Spinner';

const Search = ({ searchTerm }) => {

  const [pins, setPins] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if(searchTerm){
      setLoading(true)
      const query = searchQuery(searchTerm.toLowerCase());

      client.fetch(query)
        .then((data) =>{
          // console.log(data)
          setPins(data)
          setLoading(false)
        })
    }
    else{
      client.fetch(feedQuery)
        .then((data) =>{
          // console.log(data)
          setPins(data)
          setLoading(false)
        })
    }
  }, [searchTerm]);
  

  return (
    <div>
      {loading && <Spinner message="searching for pins"/>}
      {pins?.length !== 0 && <MasonaryLayout pins={pins}/>}
      {pins?.length === 0 && searchTerm !== '' && !loading && 
       (
        <div className="mt-10 text-center text-xl">
            No pins Found!
        </div>
       )}
    </div>
)};

export default Search;
